// import TextInput from "./components1/TextInput";

// export {TextInput};
import Map from "./components/callToApi/FetchDataStart";

export default Map;